/**
 * Krok CEN2, vytazeno v QAFIX9 — MESICNE/ROCNE JE KONVENCE CENIKU, NE VYPOCET.
 *
 * Rocni varianta tarifu je v ceniku SAMOSTATNY radek s kodem `<kod>_YEARLY`
 * (migrace 0033/0038) a stejnymi naroky jako mesicni. Prepinac proto jen
 * VYBIRA RADEK KATALOGU — zadna cena se v adminu neprepocitava a „10 mesicu
 * z 12" se pocita z OBOU cen, ne z cisla v textu.
 *
 * Do QAFIX9 tyhle tri funkce zily v `components/tariff-card.tsx`. Obrazovka
 * „Tarif a platba" (`routes/tarif.tsx`) potrebuje tutez konvenci, a druha
 * kopie by se pri prvni zmene ceniku rozesla (CLAUDE.md §8 pravidlo 2).
 */

export const YEARLY_SUFFIX = '_YEARLY';

/** Kod MESICNI varianty k libovolnemu kodu tarifu. */
export function baseCodeOf(code: string): string {
  return code.endsWith(YEARLY_SUFFIX) ? code.slice(0, -YEARLY_SUFFIX.length) : code;
}

/** Kod ROCNI varianty k libovolnemu kodu tarifu. */
export function yearlyCodeOf(code: string): string {
  return `${baseCodeOf(code)}${YEARLY_SUFFIX}`;
}

export function isYearlyCode(code: string): boolean {
  return code.endsWith(YEARLY_SUFFIX);
}

/**
 * Pocet uctovanych mesicu z OBOU cen katalogu; `null` = nejde rict (chybejici
 * cena, nula nebo neceli nasobek). Vstup je zaklad DPH jako numeric string
 * z ceniku.
 */
export function yearlyMonthsCharged(
  monthlyPriceNet: string | null | undefined,
  yearlyPriceNet: string | null | undefined,
): number | null {
  const m = Number(monthlyPriceNet ?? Number.NaN);
  const y = Number(yearlyPriceNet ?? Number.NaN);
  if (!Number.isFinite(m) || m <= 0 || !Number.isFinite(y) || y <= 0) return null;
  const months = y / m;
  return Number.isInteger(months) ? months : null;
}
